import { ChartDescription, ChartEditorContent } from '../models/pi/pi.model';
import { LanguageCodeHelper } from './language-code-helper';

export class ChartsHelper {
  static getPIChartsDescriptionsByLanguageCode(key: string, content: ChartEditorContent): ChartDescription {
    const traitDescription = content.descriptions[key];
    if (!traitDescription) {
      return { full: [], short: [] };
    }
    const full = traitDescription.full[0];
    const short =
      typeof traitDescription.short === 'string'
        ? traitDescription.short
        : LanguageCodeHelper.getDataByLanguageCode(traitDescription.short);
    return { full: full ? [full] : [], short: short ? [short] : [] };
  }

  static calculateProgress(completed: number, total: number): number {
    let progress = Math.floor((completed * 100) / total);
    if (progress > 100) {
      progress = 100;
    }
    return progress;
  }

  static getTransparentColor(color: string, opacity?: number): string {
    if (!color) {
      return '';
    }
    const r = parseInt(color.slice(1, 3), 16);
    const g = parseInt(color.slice(3, 5), 16);
    const b = parseInt(color.slice(5, 7), 16);
    const alpha = opacity ? opacity : 0.4;
    return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
  }
}
